import type { PlanningRow, Shift } from './types';

/**
 * Entrée et sortie d'un salarié (2026-11-05). La date d'entrée est `hire_date`, la date de sortie est le dernier jour
 * travaillé (`date_sortie`, incluse). En dehors de cette période, la case du planning est « hors effectif » :
 * ni heures, ni absence, non modifiable. Le créneau d'origine est gardé dans `previous` pour être rétabli si la
 * période est élargie (sortie annulée, date d'entrée corrigée). Même règle côté serveur
 * (appliquerEffectifAuxSemaines dans functions/api/[[path]].js).
 */

const jour = (d?: string | null) => (d ? String(d).slice(0, 10) : '');

export const estEffectif = (date: string, entree?: string | null, sortie?: string | null): boolean => {
    const e = jour(entree);
    const s = jour(sortie);
    return (!e || date >= e) && (!s || date <= s);
};

/** Vrai si le salarié est effectif au moins un des jours donnés (une ligne reste visible toute la semaine où il a travaillé). */
export const estEffectifSurPeriode = (dates: string[], entree?: string | null, sortie?: string | null): boolean =>
    dates.some(d => estEffectif(d, entree, sortie));

/** Applique la période d'effectif à une ligne : renvoie la ligne et si elle a changé. */
export const appliquerEffectif = (row: PlanningRow, dates: string[], entree?: string | null, sortie?: string | null): { row: PlanningRow; changed: boolean } => {
    const shifts: Record<string, Shift> = { ...(row.shifts || {}) };
    let changed = false;
    for (const d of dates) {
        const actuel = shifts[d];
        if (!estEffectif(d, entree, sortie)) {
            if (!actuel || actuel.type !== 'hors_effectif') {
                shifts[d] = { date: d, type: 'hors_effectif', serviceType: 'none', segments: [], ...(actuel ? { previous: actuel } : {}) };
                changed = true;
            }
        } else if (actuel && actuel.type === 'hors_effectif') {
            if (actuel.previous) shifts[d] = actuel.previous;
            else delete shifts[d];
            changed = true;
        }
    }
    return { row: changed ? { ...row, shifts } : row, changed };
};
